import { useHistory } from 'react-router-dom'

const useNavigation = () => {
  const history = useHistory()

  return history.push
}

export { useNavigation }
